import { useNavigate } from "react-router-dom";
import { TEMPLATE_CONFIG } from "./template.config";
import { isFeatureAllowed } from "../../../shared/utils/featureAccess";

export function useTemplateOptions(featureAccess) {
  const navigate = useNavigate();

  return TEMPLATE_CONFIG.map((template) => ({
    ...template,
    alreadyPaid: isFeatureAllowed(featureAccess, template.key, true),
    handleClick: () =>
      navigate(template.route),
  }));
}
